import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import queryString from 'query-string'
import isEmpty from 'lodash/isEmpty'

// State
import { setSortValueAndDirection } from '../../../store/actions/sort'

class SortOptionItem extends Component {
    constructor(props){
        super(props)
        
        const query = !!props.location ? queryString.parse(props.location.search) : {}
        const sort = !!query.sort ? query.sort : ''
        const dir = !!query.dir ? query.dir : ''
        props.setSortValueAndDirection(sort, dir)
    }

    setSortParams(){        
        let queryObj = {}

        const query = !!this.props.location ? queryString.parse(this.props.location.search) : {}
        const pg = !!query.pg ? query.pg : ''
        if (!!pg) queryObj.pg = pg

        const q = !!query.q ? query.q : ''
        if (!!q) queryObj.q = q

        queryObj.sort = this.props.option.value
        queryObj.dir = this.props.option.dir

        const qs = queryString.stringify(queryObj)

        // Set sort values from the store
        this.props.setSortValueAndDirection(this.props.option.value, this.props.option.dir)

        // Push new history to trigger a new search
        this.props.history.push('?' + qs)
    }

    isActive(){
        const { isAjax = false } = this.props
        const { value, dir, isDefault = null, isSetViaJS = false } = this.props.option

        return (
            (
                // Is not an ajax call
                !isAjax &&
                (
                    // The store's sortValue the value of the option
                    this.props.sortValue === value &&

                    // The store's sortDir is the value of the option
                    this.props.sortDir === dir
                )
            ) ||
            (
                (
                    // The store's sortValue is not set
                    isEmpty(this.props.sortValue) ||

                    // The store's sortDir is not set
                    isEmpty(this.props.sortDir)
                )
                // And the item is default
                && !!isDefault
            ) || (
                isSetViaJS
            )
        )
    }

    render() {
        const { index, isAjax = false } = this.props
        const { text, value, dir } = this.props.option

        let isActive = this.isActive()
        
        return (
            <div className={'sort_option' + (isActive ? ' active' : '')}
                onClick={() => isAjax ? this.props.setAjaxSortParams(value, dir, index) : this.setSortParams()}>{text}</div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sortValue: state.sort.value,
        sortDir: state.sort.dir
    }
}

export default withRouter(connect(mapStateToProps, { setSortValueAndDirection })(SortOptionItem))



// WEBPACK FOOTER //
// ./src/components/utils/sort-options/SortOptionItem.js